<div class="white-bg dropdown-shadow radius-m p-6 pt-8"  [ngClass]="mode==0?'time-container':'specific-time-container'"  id="time-container" [formGroup]="selectTime" >
    <!-- Relative time panel -->
    <ng-container *ngIf="mode==1 || mode ==0">
        <div class="relative-time-panel" #relativeTime>
            <div class="header">
                Relative Time
            </div>
            <div class="relative-time">
                <!-- List of relative times -->
                <ul class="content-m primary-text pt-3">
                    <ng-container *ngFor="let relativeTime of timeMetaData.time_panel.relative_time_options">
                        <li class="py-3" tabindex="-1" (keydown)="navigateCells($event)" (click)="relativeTime_click(relativeTime)"
                            (keydown.enter)="relativeTime_click(relativeTime)"
                            [ngClass]="{'selected-time-range': selectedTimeRange.value.toString() == relativeTime.value.toString()}">
                            {{relativeTime.disp}}</li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </ng-container>
    <!-- Date-time range picker panel -->
    <ng-container *ngIf="mode==2 || mode ==0">
        <div class="date-time-panel" #timeRange>
            <div id="timeRange">
                Custom Time Range
            </div>
            <div class="date-time-range pt-5">
                <div class="select">
                    <!-- to select range type like 'between', 'since', 'before' -->
                    <div #selectRange class="form-field1 content-s primary-text">
                        <label class="form-label-top1">{{timeMetaData.time_panel.time_panel_lables["1"]}}&#58;</label>
                        <app-overlay-select formControlName="selectRange" #range fontsize="input-m"
                            [data]="timeMetaData.time_panel.date_time_range_options" [origin]="selectRange"
                            >
                        </app-overlay-select>
                    </div>
                </div>
                <div class="time-inputs">
                    <!-- to pick start date-time -->
                    <div class="from-time" *ngIf="fromDateState">
                        <input type="datetime-local" id="from" formControlName="fromDate" [max]="maxdate"
                            [min]="minidate" tooltip="{{selectTime.controls.fromDate.value | date:'dd MMM yy HH:mm'}}">
                    </div>
                    <!-- to pick end date-time -->
                    <div class="to-time" *ngIf="toDateState">
                        <!-- <p class="label">{{timeMetaData.time_panel.time_panel_lables["2"]}}</p> -->
                        <input type="datetime-local" id="to" formControlName="toDate" [max]="maxdate" [min]="minidate"
                            tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy HH:mm'}}">
                    </div>
                    <!-- <span class="time-validation" *ngIf="selectTime.errors">{{userloginService.metaData.rule.lookbackmeta.formerrormsg.invalidtime}}</span> -->
                    <div class="error-msg">
                        <span class="time-validation content-s alert-text" *ngIf="applyclicked">{{ timepannelErrormsg |
                            oneError:selectTime.errors}}</span>
                    </div>
                </div>
                <!-- to apply the selected time range for search -->
                <div class="apply-button">
                    <button type="submit" class="submit" (click)="newDateRange_click()"
                        (keydown.enter)="newDateRange_click()"
                        [ngStyle]="selectTime.errors?{'cursor':'default'}:{'cursor':'pointer'}">{{logSearchService.lables.apply}}</button>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Surrounding time panel -->
    <!-- <mat-expansion-panel class="surrounding-time-panel" (opened)="openGroup('expansion3')" #surroundingTime>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{timeMetaData.log_time_exp_headers["3"]}}
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <hr class="horizondal-seperator">
            <div class="surrounding-time">
                <ul>
                    <li (keydown)="navigateCells($event)" tabindex="-1"
                        *ngFor="let surroundingTime of timeMetaData.time_panel.surrounding_time_options"
                        (keydown.enter)="relativeTime_click(surroundingTime)" (click)="relativeTime_click(surroundingTime)"
                        [ngClass]="{'selected-time-range': selectedTimeRange.disp == surroundingTime.disp}">
                        {{surroundingTime.disp}}</li>
                </ul>
            </div>
        </mat-expansion-panel> -->
</div>